var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_202_212)"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    "mixBlendMode": "multiply"
  },
  opacity: 0.2
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.47386 18.375C7.20971 18.3778 6.95378 18.4672 6.74529 18.6294C6.53679 18.7917 6.38725 19.0178 6.31959 19.2731C6.25192 19.5285 6.26985 19.799 6.37065 20.0432C6.47144 20.2873 6.64953 20.4917 6.87761 20.625L11.1376 23.04C11.4885 23.2395 11.8853 23.3441 12.2889 23.3438C12.506 23.3436 12.722 23.312 12.9301 23.25L19.3389 21.4238C19.8169 21.2864 20.2374 20.9975 20.537 20.6005C20.8366 20.2035 20.9991 19.7199 21.0001 19.2225V18.375H7.47386Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    "mixBlendMode": "multiply"
  },
  opacity: 0.12
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.47386 18.375C7.20971 18.3778 6.95378 18.4672 6.74529 18.6294C6.53679 18.7917 6.38725 19.0178 6.31959 19.2731C6.25192 19.5285 6.26985 19.799 6.37065 20.0432C6.47144 20.2873 6.64953 20.4917 6.87761 20.625L11.1376 23.04C11.4885 23.2395 11.8853 23.3441 12.2889 23.3438C12.506 23.3436 12.722 23.312 12.9301 23.25L19.3389 21.4238C19.8169 21.2864 20.2374 20.9975 20.537 20.6005C20.8366 20.2035 20.9991 19.7199 21.0001 19.2225V18.375H7.47386Z",
  fill: "white"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9038 0.75L14.6251 4.6875V18.375L12.9301 23.25L19.3388 21.4238C19.8168 21.2864 20.2373 20.9975 20.5369 20.6005C20.8365 20.2035 20.9991 19.7199 21.0001 19.2225V4.7775C21.0003 4.27885 20.8378 3.79374 20.5373 3.39579C20.2368 2.99785 19.8147 2.70879 19.3351 2.5725L12.9038 0.75Z",
  fill: "url(#paint0_linear_202_212)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.7775 18.2289L6.6525 17.2164C6.90965 17.0751 7.12402 16.8672 7.27313 16.6145C7.42225 16.3618 7.50061 16.0736 7.5 15.7802V8.41142C7.50035 8.07577 7.60375 7.74833 7.79624 7.47335C7.98872 7.19837 8.261 6.98914 8.57625 6.87392L14.625 4.68767V3.02642C14.6243 2.51154 14.4559 2.01088 14.1454 1.60019C13.8348 1.1895 13.399 0.891116 12.9038 0.750174C12.6929 0.689614 12.4744 0.659311 12.255 0.660174V0.660174C11.8423 0.661118 11.4368 0.768309 11.0775 0.971424L4.155 4.92017C3.80421 5.12006 3.51258 5.40923 3.30972 5.7583C3.10686 6.10738 3 6.50393 3 6.90767V17.1677C2.99948 17.3765 3.05329 17.5819 3.15614 17.7636C3.259 17.9454 3.40737 18.0972 3.58667 18.2043C3.76597 18.3113 3.97004 18.3699 4.17882 18.3742C4.38761 18.3785 4.59392 18.3285 4.7775 18.2289V18.2289Z",
  fill: "url(#paint1_linear_202_212)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6251 18.375H7.47386C7.20971 18.3778 6.95378 18.4672 6.74529 18.6294C6.53679 18.7917 6.38725 19.0178 6.31959 19.2731C6.25192 19.5285 6.26985 19.799 6.37065 20.0432C6.47144 20.2873 6.64953 20.4917 6.87761 20.625L11.1376 23.04C11.4885 23.2395 11.8853 23.3441 12.2889 23.3438V23.3438C12.506 23.3436 12.722 23.312 12.9301 23.25C13.4193 23.111 13.8496 22.816 14.1556 22.4098C14.4616 22.0036 14.6265 21.5085 14.6251 21V18.375Z",
  fill: "url(#paint2_linear_202_212)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.7775 18.2289L6.6525 17.2164C6.90965 17.0751 7.12402 16.8672 7.27313 16.6145C7.42225 16.3618 7.50061 16.0736 7.5 15.7802V8.41142C7.50035 8.07577 7.60375 7.74833 7.79624 7.47335C7.98872 7.19837 8.261 6.98914 8.57625 6.87392L14.625 4.68767V3.02642C14.6243 2.51154 14.4559 2.01088 14.1454 1.60019C13.8348 1.1895 13.399 0.891116 12.9038 0.750174C12.6929 0.689614 12.4744 0.659311 12.255 0.660174V0.660174C11.8423 0.661118 11.4368 0.768309 11.0775 0.971424L4.155 4.92017C3.80421 5.12006 3.51258 5.40923 3.30972 5.7583C3.10686 6.10738 3 6.50393 3 6.90767V17.1677C2.99948 17.3765 3.05329 17.5819 3.15614 17.7636C3.259 17.9454 3.40737 18.0972 3.58667 18.2043C3.76597 18.3113 3.97004 18.3699 4.17882 18.3742C4.38761 18.3785 4.59392 18.3285 4.7775 18.2289V18.2289Z",
  fill: "url(#paint3_linear_202_212)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6251 18.375H7.47386C7.20971 18.3778 6.95378 18.4672 6.74529 18.6294C6.53679 18.7917 6.38725 19.0178 6.31959 19.2731C6.25192 19.5285 6.26985 19.799 6.37065 20.0432C6.47144 20.2873 6.64953 20.4917 6.87761 20.625L11.1376 23.04C11.4885 23.2395 11.8853 23.3441 12.2889 23.3438V23.3438C12.506 23.3436 12.722 23.312 12.9301 23.25C13.4193 23.111 13.8496 22.816 14.1556 22.4098C14.4616 22.0036 14.6265 21.5085 14.6251 21V18.375Z",
  fill: "url(#paint4_linear_202_212)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_202_212",
  x1: 16.9501,
  y1: -0.5325,
  x2: 16.9501,
  y2: 21.675,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#EF8400"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#E25C01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#DB4401"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#D83B01"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_202_212",
  x1: 12.945,
  y1: 0.251424,
  x2: 1.185,
  y2: 17.0439,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#800600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#C72127"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#C13959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#BC4B81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#B95799"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B85BA2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_202_212",
  x1: 6.93761,
  y1: 20.8612,
  x2: 22.2901,
  y2: 20.8612,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F32B44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#A4070A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_202_212",
  x1: 13.185,
  y1: -0.0898259,
  x2: 10.695,
  y2: 3.46517,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_202_212",
  x1: 17.3701,
  y1: 21.2062,
  x2: 10.4964,
  y2: 20.6062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_202_212"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
export default __webpack_public_path__ + "static/media/office365.fb602cc1.svg";
export { SvgComponent as ReactComponent };